<template>
  <v-alert
    class="mx-3"
    type="error"
    dense
    text
    variant="tonal"
    icon="mdi-alert-circle-outline"
    style="margin-right: 0px !important; margin-left: 0px !important">
    Warning: Pressing start upgrade will upgrade the template to a newer version
    and allow it to be used when the older version is not live. It is not
    recommended to do this during an event or broadcast as loading a template
    can affect playback performance. Only do this if you know what you're doing.
  </v-alert>

  <!--  Conditional Buttons -->
  <input
    id="uploadVZA"
    accept=".vza,.orb"
    type="file"
    style="display: none"
    @input="sendToUploadQueue()" />

  <v-btn
    @click="openFileDialog"
    class="my-3"
    variant="flat"
    block
    v-if="!deluge.template_upgrade[userEditObj.uid]">
    Upload VZA
  </v-btn>
  <v-btn
    class="my-3"
    variant="flat"
    block
    v-else-if="!deluge.template_upgrade[userEditObj.uid].filename"
    :loading="true"></v-btn>
  <v-btn
    class="my-3"
    variant="flat"
    block
    v-else
    color="primary">
    {{ deluge.template_upgrade[userEditObj.uid].filename }}
  </v-btn>
  <!-- END Conditional Buttons -->
  <v-btn
    :disabled="!canUpgrade()"
    @click="startUpgrade()"
    variant="flat"
    primary
    :loading="upgrade_loading"
    block>
    Start Upgrade
  </v-btn>
</template>

<script setup>
import { ref } from 'vue';
import { deluge } from '@/stores/deluge.js';
import { state } from '../../../stores/deluge';
import { $http } from '../../../stores/http';
const upgrade_loading = ref(false);
const props = defineProps(['userEditObj']);

function canUpgrade() {
  if (deluge.template_upgrade[props.userEditObj.uid]) {
    if (deluge.template_upgrade[props.userEditObj.uid].filename) {
      return true;
    }
  }
  return false;
}

function sendToUploadQueue() {
  const file_input = document.getElementById('uploadVZA');
  for (const file of file_input.files) {
    file.src_uid = props.userEditObj.uid;
    state.upload_files.push(file);
  }
  file_input.files = new DataTransfer().files;
}
function openFileDialog() {
  const file_input = document.getElementById('uploadVZA');
  file_input.click();
}

async function startUpgrade() {
  upgrade_loading.value = true;
  try {
    // This operation can be long-running; increase timeout to 5 minutes (300000ms)
    await $http(
      'PUT',
      `/upgrade_template?template_uid=${props.userEditObj.uid}`,
      null,
      300000
    );
  } catch (error) {
    console.log(error);
  } finally {
    // Ensure loading state is cleared even if request fails or errors
    upgrade_loading.value = false;
  }
}
</script>
